import { RSimInventoryDetailsPage } from './RSimInventoryDetailsPage';
import Box from '@mui/material/Box';
import { DetailsSkeleton } from 'common/components/DetailsSkeleton';
import { SuspenseLoadingView } from 'common/components/SuspenseLoadingView';
import { Outlet } from 'react-router';
import { PrimarySimGrid } from './components/PrimarySimGrid';
import { SecondarySimGrid } from './components/SecondarySimGrid';
import {
  rSimInventoryDetails,
  rSimInventorySimDetailsSkeletonMediumScreen,
  rSimInventorySimDetailsSkeletonSmallScreen,
} from './RSimInventoryDetailsPage.style';
import { useTheme } from '@mui/material/styles';
import { palette } from 'theme/palette';
import { RSimProductTagProvider } from 'rSimInventory/RSimTags/RSimProductTagProvider';
import { rsimProductDetailsQueries } from './utils/rsimProductDetailsQueries';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { ErrorCodes } from 'src/common/responseCodes';
import { useTranslation } from 'react-i18next';

const IGNORED_ERRORS = [ErrorCodes.NotFound];
export const RSimInventoryEntry = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <TabPanelWithErrorHandling
      name={t('rSimInventory.details.tabs.general')}
      ignoreErrorMessages={IGNORED_ERRORS}
    >
      <RSimProductTagProvider>
        <Box sx={{ height: '100%' }}>
          <SuspenseLoadingView
            loadFallback={
              <Box
                sx={{
                  ...rSimInventoryDetails,
                  mt: 64,
                }}
              >
                <DetailsSkeleton />
                <Box
                  sx={{
                    ...rSimInventorySimDetailsSkeletonSmallScreen,
                    [theme.breakpoints.up('md')]: {
                      ...rSimInventorySimDetailsSkeletonMediumScreen,
                    },
                  }}
                >
                  <PrimarySimGrid sx={{ gridArea: 'skeleton1', pl: 0 }} hideTopBorder={true}>
                    <DetailsSkeleton />
                  </PrimarySimGrid>
                  <div
                    style={{
                      gridArea: 'divider',
                      borderRight: `1px solid ${palette.border}`,
                    }}
                  ></div>
                  <SecondarySimGrid sx={{ gridArea: 'skeleton2', pl: 0 }} hideTopBorder={true}>
                    <DetailsSkeleton />
                  </SecondarySimGrid>
                </Box>
              </Box>
            }
            queryKey={[...rsimProductDetailsQueries.allDetails]}
          >
            <RSimInventoryDetailsPage />
            <Outlet />
          </SuspenseLoadingView>
        </Box>
      </RSimProductTagProvider>
    </TabPanelWithErrorHandling>
  );
};
